import { IMessageFromDialog } from "@/services";

export interface IMeetingInfo {
  StartTime: string;
  EndTime: string;
  Guid?: string;
}

export interface ITimeInfo {
  dateTime?: Date | null | string;
  timeZone?: string;
}

export class TimeInfo {
  dateTime: Date | null;
  timeZone: string;

  constructor(data?: ITimeInfo) {
    this.dateTime = data?.dateTime ? new Date(data?.dateTime) : null;
    this.timeZone = data?.timeZone || ""
  }

  toJson(): ITimeInfo {
    return {
      dateTime: this.dateTime,
      timeZone: this.timeZone
    }
  }
}

export interface IDropdownOption {
  id: string;
  label: string;
}

export interface IDialogEventData {
  message?: string;
  type?: string;
  origin?: string;
  error?: number;
}

export class DialogEventData {
  message: IMessageFromDialog;
  type: string;
  origin: string;
  error?: number;

  constructor(data?: IDialogEventData) {
    this.type = data?.type || "";
    this.origin = data?.origin || "";
    const messageClone: IMessageFromDialog = JSON.parse(data?.message || "{}") as IMessageFromDialog;
    console.log("messageClone", messageClone);
    this.message = messageClone;
    this.error = data?.error || undefined
  }
}